module.exports = __webpack_public_path__ + "_assets/img/store.15d48a7a.png";